import qs from 'qs';
import {
  apiPostUseCouponCode, // 使用折扣卷
  apiPostUpdateCart, // 修改数量
  apiGetCartListData, // 购物车
} from './testJsonApi';
import * as constType from '../constants/actionsTypes';
import { cartJsonData } from '../controller/CartEntryController';

const resCartApiData = [];

// resCartApiData = eval(`(${resCartApiData})`);
const cartIndexMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'MID_POST_USE_COUPON_CODE': {
      // CSRFToken jsp變數
      const data = {
        code: action.payload,
        cSRFToken: qs.stringify({ CSRFToken }),
      };
      apiPostUseCouponCode('post', data).then((res) => {
        if (res.status === 200) {
          const rtnObj = JSON.parse(res.data);
          const rtnCode = parseInt(rtnObj.rtnCode);
          const { rtnMsg } = rtnObj;

          if (rtnCode === -1) {
            alert(rtnMsg);
          } else {
            alert('成功使用折扣碼');
          }
        }
        // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
        window.location.reload();
      }).catch((err) => {
        if (err.status === '405') {
          alert('很抱歉，您閒置已久將重新整理頁面，請稍後再重新操作');
          window.location.reload();
        } else {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');
        }
        // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
      });

      return next(action);
    }
    case 'MID_POST_UPDATE_CART': {
      const request = action.payload;
      request.CSRFToken = CSRFToken;
      const postRequest = qs.stringify(request);
      // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });

      apiPostUpdateCart('post', postRequest).then((res) => {
        if (res.status === 200) {
          const rtnObj = JSON.parse(res.data);
          const rtnCode = parseInt(rtnObj.rtnCode);
          const { rtnMsg } = rtnObj;

          if (rtnCode === -1) {
            alert(rtnMsg);
          } else {
            window.location.reload();
          }
        } else {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');
        }
        // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
      }).catch((err) => {
        if (err.status === '405') {
          alert('很抱歉，您閒置已久將重新整理頁面，請稍後再重新操作');
          window.location.reload();
        } else {
          alert('很抱歉！目前系統忙碌中，請稍候再試。');
        }
        // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
      });

      return next(action);
    }
    case 'MID_GET_CART_LIST_DATA': {
      // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: true });

      apiGetCartListData('get').then((res) => {
        const resData = res.data;
        const resJSON = JSON.parse(resData);
        store.dispatch({ type: constType.UPDATE_CART_LIST_DATA, payload: cartJsonData(resJSON) });

        // store.dispatch({ type: constType.CHANGE_EFFECT_ISLOADING, payload: false });
      }).catch((err) => {
        // const httpStatus = err.response;
        // store.dispatch({ type: constType.UPDATE_CART_LIST_DATA, payload: cartJsonData(resCartApiData) });

      });

      return next(action);
    }
    case 'MID_UPDATE_IS_SHOW_COUPON_LIST_MODAL': {
      store.dispatch({
        type: constType.UPDATE_IS_SHOW_COUPON_LIST_MODAL,
        payload: action.payload,
      });

      return next(action);
    }
    default:
      return next(action);
  }
};

export default cartIndexMiddleware;
